import React, { useEffect, useRef, useState } from 'react';
import * as xlsx from 'xlsx';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import AdminBreadCrump from '../AdminPanel/Heading/AdminBreadCrump';
import { Icon } from '@iconify/react';
// import "../PagesStyles/AdminMasters.css";
import DownloadIcon from '@mui/icons-material/Download';
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a131,
  a132,
  a133,
  a137,
  a138,
  a139,
  a18,
  a191,
  a192,
  a193,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
  postAdminadddiamondsizeweightrate,
} from '../../Api/RootApiPath';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../Other Functions/AlertMessage';
import { useNavigate } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import style from './AddDaimondNew.module.css';
import Customertable from 'Components/support/customervendor/customer';
import toast from 'react-hot-toast';

export default function AddDiamondNew() {
  const navigate = useNavigate();
  const [excelData, setExcelData] = useState([]);
  const fileInputRef = useRef(null);
  const [active, setActive] = useState('AddNew');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [editId, setEditId] = useState('');
  const [uploadCheck, setUploadCheck] = useState(false);
  const [diamondShapes, setDiamondShapes] = useState([]);
  const [diamondClarities, setDiamondClarities] = useState([]);
  const [diamondColors, setDiamondColors] = useState([]);
  const [diamondCuts, setDiamondCuts] = useState([]);
  const [settingTypes, setSettingTypes] = useState([]);
  const [defaultTemplateData, setDefaultTemplateData] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');

  const [loading, setLoading] = useState(false);

  const [searchInput, setSearchInput] = useState('');

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    DiamondSize: '',
    Sleve: '',
    DiamondWeight: '',
    DiamondPurchaseRate: '',
    DiamondSellRate: '',
    DiamondMargin: '',
    CompanyId: 0,
    BranchId: 0,
    DiamondShape: '',
    DiamondClarity: '',
    DiamondColor: '',
    DiamondCut: '',
    SettingType: '',
    CounterId: 0,
    EmployeeId: 0,
    TemplateName: '',

    OldEntry: false,
  });

  const [allTableData, setAllTableData] = useState([]);
  const [resData, setResData] = useState('');
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const allStates = useSelector((state) => state);
  const [defaultTemplateId, setDefaultTemplateId] = useState('');
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const companyId = adminLoggedIn.CompanyId;
  const branchId = adminLoggedIn.BranchId;
  const counterId = adminLoggedIn.CounterId;
  const employeeId = adminLoggedIn.EmployeeId;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  useEffect(() => {
    const fetchDiamondAttributes = async () => {
      const response = await fetch(
        'https://rrgold.loyalstring.co.in/api/ProductMaster/GetAllDiamondAttributes',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ClientCode: clientCode,
          }),
        }
      );
      const data = await response.json();

      const shapes = data.filter(
        (item) => item.DiamondAttribute === 'DiamondShape'
      );
      const clarities = data.filter(
        (item) => item.DiamondAttribute === 'DiamondClarity'
      );
      const colors = data.filter(
        (item) => item.DiamondAttribute === 'DiamondColour'
      );
      const cuts = data.filter(
        (item) => item.DiamondAttribute === 'DiamondCut'
      );
      const settings = data.filter(
        (item) => item.DiamondAttribute === 'DiamondSettingType'
      );

      setDiamondShapes(shapes);
      setDiamondClarities(clarities);
      setDiamondColors(colors);
      setDiamondCuts(cuts);
      setSettingTypes(settings);
    };

    fetchDiamondAttributes();
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a191, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data) {
        setAllCategories(data);
      } else {
        setActive('addNew');
      }
      // else {
      //     setActive("addNew");
      //     document
      //         .getElementById("addCategoryListTitle")
      //         .classList.add("activeCategoryTitle");
      //     document
      //         .getElementById("addCategoryListLogo")
      //         .classList.add("activeCategoryLogo");
      //     document.getElementById("addCategoryListTitle").click();
      // }
    } catch (error) {
      console.log(error);
    }
  };

  console.log('allCategories', allCategories);

  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Departments First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);
  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Roles First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Category First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllProductsList();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    if (name === 'DiamondMargin') {
      const diamondPurchaseRate = parseFloat(
        newCategory.DiamondPurchaseRate || 0
      );
      const diamondMargin = parseFloat(value || 0);
      const diamondSellRate = (
        diamondPurchaseRate *
        (1 + diamondMargin / 100)
      ).toFixed(2);

      setNewCategory({
        ...newCategory,
        [name]: value,
        DiamondSellRate: diamondSellRate,
      });
    } else if (name === 'DiamondPurchaseRate') {
      const diamondPurchaseRate = parseFloat(value || 0);
      const diamondMargin = parseFloat(newCategory.DiamondMargin || 0);
      const diamondSellRate = (
        diamondPurchaseRate *
        (1 + diamondMargin / 100)
      ).toFixed(2);

      setNewCategory({
        ...newCategory,
        [name]: value,
        DiamondSellRate: diamondSellRate,
      });
    } else if (name === 'DiamondSellRate') {
      const diamondSellRate = parseFloat(value || 0);
      const diamondPurchaseRate = parseFloat(
        newCategory.DiamondPurchaseRate || 0
      );

      if (diamondPurchaseRate !== 0) {
        const diamondMargin = (
          (diamondSellRate / diamondPurchaseRate - 1) *
          100
        ).toFixed(2);

        setNewCategory({
          ...newCategory,
          [name]: value,
          DiamondMargin: diamondMargin,
        });
      } else {
        setNewCategory({
          ...newCategory,
          [name]: value,
        });
      }
    } else {
      setNewCategory({ ...newCategory, [name]: value });
    }
  };

  useEffect(() => {
    async function findNullData() {
      const payload = {
        ClientCode: clientCode,
      };
      const response = await fetch(
        'https://testing.loyalstring.co.in/api/ProductMaster/GetDiamondSizeWeightRateTemplate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      const isNullData = data?.find((item) => item.TemplateName === '');
      if (isNullData) {
        setDefaultTemplateId(isNullData.Id);
      } else {
        setDefaultTemplateId('');
      }
    }

    if (!defaultTemplateId) {
      findNullData();
    }
  }, [defaultTemplateId]);

  async function fetchDefaultTemplate() {
    const payload = {
      Id: defaultTemplateId,
      ClientCode: clientCode,
    };
    const response = await fetch(
      'https://testing.loyalstring.co.in/api/ProductMaster/GetDiamondSizeWeightRateTemplate',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
        },
        body: JSON.stringify(payload),
      }
    );
    const data = await response.json();
    setDefaultTemplateData(data[0]?.DiamondSizeWeightRates);
  }

  useEffect(() => {
    if (defaultTemplateId) {
      fetchDefaultTemplate();
    }
  }, [defaultTemplateId]);

  const addNewCategory = async () => {
    if (!allTableData?.length) {
      toast.error('Atleast one entry required to run this functionality', {
        duration: 3000,
        position: 'top-center',
      });
      return;
    }
    setLoading(true);
    let arr = [];

    allTableData.map((item) => {
      arr.push({
        ClientCode: clientCode,
        DiamondSize: item.DiamondSize,
        DiamondShape: getShapeValue(null, item.DiamondShape),
        DiamondClarity: getDiamondClarity(null, item.DiamondClarity),
        DiamondColor: getDiamondColor(null, item.DiamondColor),
        DiamondCut: getDiamondCut(null, item.DiamondCut),
        SettingType: getSettingType(null, item.SettingType),
        Sleve: item.Sleve,
        DiamondWeight: item.DiamondWeight,
        DiamondPurchaseRate: item.DiamondPurchaseRate,
        DiamondSellRate: item.DiamondSellRate,
        DiamondMargin: String(item.DiamondMargin),
        CompanyId: companyId ? companyId : 0,
        BranchId: branchId ? branchId : 0,
        CounterId: counterId ? counterId : 0,
        EmployeeId: employeeId ? employeeId : 0,

        ...(item.OldEntry ? { Id: item.Id } : {}),
      });
    });

    try {
      if (defaultTemplateId && !newCategory.TemplateName) {
        const payload = {
          Id: defaultTemplateId,
          TemplateName: newCategory.TemplateName,
          DiamondSizeWeightRates: editId
            ? arr
            : arr.concat(defaultTemplateData),
          ClientCode: clientCode,
        };
        const response = await fetch(postAdminadddiamondsizeweightrate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        setResData(data);
        setEditId('');
        setDefaultTemplateId('');
      } else {
        if (editId) {
          const payload = {
            Id: editId,
            TemplateName: newCategory.TemplateName,
            DiamondSizeWeightRates: arr,
            ClientCode: clientCode,
          };
          const response = await fetch(postAdminadddiamondsizeweightrate, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          setResData(data);
          setEditId('');
        } else {
          const payload = {
            TemplateName: newCategory.TemplateName,
            DiamondSizeWeightRates: arr,
            ClientCode: clientCode,
          };
          const response = await fetch(postAdminadddiamondsizeweightrate, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          setResData(data);
        }
      }
      fetchAllCategory();
      setActive('List');
      setNewCategory({
        DiamondSize: '',
        Sleve: '',
        DiamondWeight: '',
        DiamondPurchaseRate: '',
        DiamondSellRate: '',
        DiamondMargin: '',
        DiamondShape: '',
        DiamondClarity: '',
        DiamondColor: '',
        DiamondCut: '',
        SettingType: '',
        CompanyId: 0,
        BranchId: 0,
        CounterId: 0,
        EmployeeId: 0,
        TemplateName: '',
        OldEntry: false,
      });

      if (resData.Message) {
        // alert(data.message);
        setMessageType('error');
        setMessageToShow(resData.Message);
        setShowError(true);
        setActive('AddNew');
        toast.error(resData?.message, {
          duration: 3000,
          position: 'top-center',
        });
      } else {
        toast.success('Diamond Size/Weight/Rate Added Successfully', {
          duration: 3000,
          position: 'top-center',
        });
        setMessageType('success');
        setMessageToShow('Diamond Size/Weight/Rate Added Successfully');
        setShowError(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
    setDefaultTemplateId('');
  };
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleTemplateDownload = (e, item) => {
    e.stopPropagation();
    const transformedData = item.DiamondSizeWeightRates.map((data, index) => {
      return {
        Shape: getShapeValue(data.DiamondShape),
        Clarity: getDiamondClarity(data.DiamondClarity),
        Color: getDiamondColor(data.DiamondColor),
        Cut: getDiamondCut(data.DiamondCut),
        Setting: getSettingType(data.SettingType),
        Size: data.DiamondSize,
        Sleve: data.Sleve,
        Weight: data.DiamondWeight,
        'Purchase Rate': data.DiamondPurchaseRate,
        Margin: data.DiamondMargin,
        'Sell Rate': data.DiamondSellRate,
      };
    });
    const workbook = xlsx.utils.book_new();
    const worksheet = xlsx.utils.json_to_sheet(transformedData);
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    xlsx.writeFile(
      workbook,
      `${item.TemplateName ? item.TemplateName : 'DefaultTemplate'}.xlsx`
    );
  };

  function getShapeValue(id, shape) {
    if (id) {
      const shapeValue = diamondShapes?.find((item) => item.Id == id);
      return id ? shapeValue?.DiamondValue : '';
    }
    if (shape) {
      const shapeValue = diamondShapes?.find(
        (item) => item.DiamondValue == shape
      );
      return shape ? shapeValue?.Id : '';
    }
  }

  function getDiamondClarity(id, clarity) {
    if (id) {
      const clarityValue = diamondClarities?.find((item) => item.Id == id);
      return id ? clarityValue?.DiamondValue : '';
    }
    if (clarity) {
      const clarityValue = diamondClarities?.find(
        (item) => item.DiamondValue == clarity
      );
      return clarity ? clarityValue?.Id : '';
    }
  }

  function getDiamondColor(id, color) {
    if (id) {
      const colorValue = diamondColors?.find((item) => item.Id == id);
      return id ? colorValue?.DiamondValue : '';
    }
    if (color) {
      const shapeValue = diamondColors?.find(
        (item) => item.DiamondValue == color
      );
      return color ? shapeValue?.Id : '';
    }
  }

  function getDiamondCut(id, cut) {
    if (id) {
      const cutValue = diamondCuts?.find((item) => item.Id == id);
      return id ? cutValue?.DiamondValue : '';
    }
    if (cut) {
      const cutValue = diamondCuts?.find((item) => item.DiamondValue == cut);
      return cut ? cutValue?.Id : '';
    }
  }

  function getSettingType(id, settingType) {
    if (id) {
      const settingTypeValue = settingTypes?.find((item) => item.Id == id);
      return id ? settingTypeValue?.DiamondValue : '';
    }
    if (settingType) {
      const shapeValue = settingTypes?.find(
        (item) => item.DiamondValue == settingType
      );
      return settingType ? shapeValue?.Id : '';
    }
  }

  const handleEditData = (data, index) => {
    const filteredData = allTableData.filter((item, ind) => ind !== index);
    setAllTableData(filteredData);
    setNewCategory({
      ...data,
      DiamondShape: getShapeValue(null, data.DiamondShape),
      DiamondClarity: getDiamondClarity(null, data.DiamondClarity),
      DiamondCut: getDiamondCut(null, data.DiamondCut),
      DiamondColor: getDiamondColor(null, data.DiamondColor),
      SettingType: getSettingType(null, data.SettingType),
      OldEntry: true,
    });
    setActive('AddNew');
  };

  const handleEditClick = async (e, item, index) => {
    e.stopPropagation();

    const updatedData = item.DiamondSizeWeightRates.map((rate) => ({
      ...rate,
      DiamondShape: getShapeValue(rate.DiamondShape),
      SettingType: getSettingType(rate.SettingType),
      DiamondCut: getDiamondCut(rate.DiamondCut),
      DiamondColor: getDiamondColor(rate.DiamondColor),
      DiamondClarity: getDiamondClarity(rate.DiamondClarity),
      TemplateName: item.TemplateName,
      mainId: item.Id,
    }));
    setAllTableData(updatedData);
    setActive('addNew');

    const payload = {
      id: item.Id,
      ClientCode: item.ClientCode,
    };
    setEditId(item.Id);
    try {
      setNewCategory({ ...newCategory, TemplateName: item.TemplateName });
    } catch (error) {
      console.error(
        'There has been a problem with your fetch operation:',
        error
      );
    }
  };

  function handleAdd(e) {
    e.preventDefault();
    if (
      newCategory.DiamondSize !== '' &&
      newCategory.DiamondWeight !== '' &&
      newCategory.DiamondShape
    ) {
      const stepFormData = {
        ClientCode: clientCode,
        DiamondSize: newCategory.DiamondSize,
        DiamondShape: getShapeValue(newCategory.DiamondShape),
        DiamondClarity: getDiamondClarity(newCategory.DiamondClarity),
        DiamondColor: getDiamondColor(newCategory.DiamondColor),
        DiamondCut: getDiamondCut(newCategory.DiamondCut),
        SettingType: getSettingType(newCategory.SettingType),
        TemplateName: newCategory.TemplateName,
        Sleve: newCategory.Sleve,
        DiamondWeight: newCategory.DiamondWeight,
        DiamondPurchaseRate: newCategory.DiamondPurchaseRate,
        DiamondSellRate: newCategory.DiamondSellRate,
        DiamondMargin: newCategory.DiamondMargin,
        CompanyId: companyId ? companyId : 0,
        BranchId: branchId ? branchId : 0,
        CounterId: counterId ? counterId : 0,
        EmployeeId: employeeId ? employeeId : 0,

        OldEntry: false,

        ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
      };
      setAllTableData((list) => [
        ...list,
        { ...stepFormData, TemplateName: newCategory.TemplateName },
      ]);
      setNewCategory({
        DiamondSize: '',
        Sleve: '',
        DiamondWeight: '',
        DiamondPurchaseRate: '',
        DiamondSellRate: '',
        DiamondMargin: '',
        DiamondShape: '',
        DiamondClarity: '',
        DiamondColor: '',
        DiamondCut: '',
        SettingType: '',
        CompanyId: 0,
        BranchId: 0,
        CounterId: 0,
        EmployeeId: 0,
        TemplateName: newCategory.TemplateName,
        OldEntry: false,
      });
    }
  }

  function handleDeleteData(index) {
    const filteredData = allTableData.filter((item, ind) => ind !== index);
    setAllTableData(filteredData);
  }

  const handleDeleteDatalist = async (e, x) => {
    e.stopPropagation();
    const payload = {
      Id: x.Id,
      ClientCode: clientCode,
    };

    try {
      const response = await fetch(
        'https://testing.loyalstring.co.in/api/ProductMaster/DeleteDiamondSizeWeightRateTemplate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      // const updatedCategories = allCategories.filter((_, i) => i !== index);
      // setAllCategories(updatedCategories);
      fetchAllCategory();
      if (result.Message) {
        setMessageType('error');
        setMessageToShow(result.Message);
        setShowError(true);
        toast.error(result?.Message, {
          duration: 3000,
          position: 'top-center',
        });
      } else {
        setMessageType('success');
        setMessageToShow('Diamond Size/Weight/Rate Deleted Successfully');
        setShowError(true);
        toast.success('Diamond Size/Weight/Rate Deleted Successfully', {
          duration: 3000,
          position: 'top-center',
        });
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };
  const keyMapping = {
    Clarity: 'DiamondClarity',
    Color: 'DiamondColor',
    Cut: 'DiamondCut',
    Margin: 'DiamondMargin',
    PurchaseRate: 'DiamondPurchaseRate',
    SellRate: 'DiamondSellRate',
    Setting: 'SettingType',
    Shape: 'DiamondShape',
    Size: 'DiamondSize',
    Sleve: 'Sleve',
    Weight: 'DiamondWeight',
  };
  const handleFileUpload = async (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];
    if (file) {
      const data = await file.arrayBuffer();
      const workbook = xlsx.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = xlsx.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
      });

      const headers = jsonData[0];
      const rows = jsonData.slice(1);
      let uploadCheckLocal = false;

      const arrayOfObjects = rows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          const newKey = keyMapping[header] || header;
          let value = row[index];
          if (newKey === 'DiamondShape') {
            if (value) {
              const checkShape = diamondShapes.find(
                (item) => item.DiamondValue === value.toUpperCase()
              );
              if (checkShape) {
                value = value.toUpperCase();
              } else {
                uploadCheckLocal = true;
              }
            }
          }
          if (newKey === 'DiamondClarity') {
            if (value) {
              const checkShape = diamondClarities.find(
                (item) => item.DiamondValue == value.toUpperCase()
              );
              if (checkShape || value === '') {
                value = value.toUpperCase();
              } else {
                uploadCheckLocal = true;
              }
            }
          }
          if (newKey === 'DiamondColor') {
            if (value) {
              const checkShape = diamondColors.find(
                (item) => item.DiamondValue === value.toUpperCase()
              );
              if (checkShape || value === '') {
                value = value.toUpperCase();
              } else {
                uploadCheckLocal = true;
              }
            }
          }
          if (newKey === 'DiamondCut') {
            if (value) {
              const checkShape = diamondCuts.find(
                (item) => item.DiamondValue === value.toUpperCase()
              );
              if (checkShape || value === '') {
                value = value.toUpperCase();
              } else {
                uploadCheckLocal = true;
              }
            }
          }
          if (newKey === 'SettingType') {
            if (value) {
              const checkShape = settingTypes.find(
                (item) => item.DiamondValue === value.toUpperCase()
              );
              if (checkShape || value === '') {
                value = value.toUpperCase();
              } else {
                uploadCheckLocal = true;
              }
            }
          }
          if (
            newKey === 'Sleve' ||
            newKey === 'DiamondSellRate' ||
            newKey === 'DiamondPurchaseRate' ||
            newKey === 'DiamondWeight' ||
            newKey === 'DiamondSize' ||
            newKey === 'DiamondMargin'
          ) {
            value = value.toString();
          }
          obj[newKey] = value;
        });
        obj['TemplateName'] = newCategory.TemplateName;
        obj['OldEntry'] = false;
        obj['CompanyId'] = companyId ? companyId : 0;
        obj['BranchId'] = branchId ? branchId : 0;
        obj['CounterId'] = counterId ? counterId : 0;
        obj['EmployeeId'] = employeeId ? employeeId : 0;
        obj['ClientCode'] = clientCode;
        return obj;
      });

      setUploadCheck(uploadCheckLocal);

      if (uploadCheckLocal) {
        setMessageType('error');
        setMessageToShow('Shape/Clarity/Color/Cut/Setting Value is invalid');
        setShowError(true);
        setUploadCheck(false);
      } else {
        console.log('ARRAYOFOBJECT : ', arrayOfObjects);
        setAllTableData(arrayOfObjects);
      }

      fileInput.value = '';
    }
  };
  const handleImportClick = () => {
    if (newCategory.TemplateName) {
      fileInputRef.current.click();
    } else {
      setMessageType('error');
      setMessageToShow('Template name is mandatory when excel imported');
      setShowError(true);
    }
  };
  const handleDownload = () => {
    const sampleData = [
      {
        Shape: 'Round',
        Clarity: 'VVS1',
        Color: 'E',
        Cut: '',
        Setting: '',
        Size: '',
        Sleve: '',
        Weight: '',
        PurchaseRate: '1000',
        Margin: '20',
        SellRate: '1800',
      },
    ];
    const workbook = xlsx.utils.book_new();
    const worksheet = xlsx.utils.json_to_sheet(sampleData);
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    xlsx.writeFile(workbook, 'downloadSample.xlsx');
  };

  const columns = [
    { key: 'serialNumber', label: 'S.No', type: 'read', priority: 2 },
    { key: 'TemplateName', label: 'Template Name', type: 'read', priority: 1 },

    { key: 'DiaShape', label: 'Dia. Shape', type: 'read', priority: 3 },
    { key: 'DiaClarity', label: 'Dia. Clarity', type: 'read', priority: 4 },
    {
      key: 'DiaSize',
      label: 'Dia. Size',
      type: 'read',
      priority: 5,
    },
    { key: 'Sieve', label: 'Sieve', type: 'read', priority: 6 },

    {
      key: 'DiaWeight',
      label: 'Dia. Weight',
      type: 'read',
      priority: 7,
    },
    {
      key: 'DiaPurchaseRate',
      label: 'Dia. Purchase Rate',
      type: 'read',
      priority: 8,
    },
    {
      key: 'DiazSellRate',
      label: 'Dia. Weight',
      type: 'read',
      priority: 9,
    },
  ];

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error('Submit button ref is not available');
        }
      }
    }
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log('Searching for:', searchTerm);
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {/* {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null} */}
        <AdminBreadCrump
          title={'Add Diamond Template'}
          companyName={'Loyalstring'}
          module={'Product Masters'}
          page={'Diamond Template'}
        />

        {active == 'List' ? (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <div className={style['white-space']}>
                  <div className={style['icon-div']}>
                    <button
                      onClick={() => setActive('AddNew')}
                      // style={{ width: "20%" }}
                      className={style['custom-btn']}
                    >
                      New
                      <Icon style={{ fontSize: '20px' }} icon="mdi:plus" />
                    </button>

                    {/* <Icon
                      style={{
                        fontSize: "28px ",
                        color: "#0077d4",
                        cursor: "pointer",
                      }}
                      icon="bx:export"
                    /> */}
                    {/* <button
                      style={{ width: "30%" }}
                      className={style["custom-btn"]}
                    >
                      <Icon
                        style={{ fontSize: "24px " }}
                        icon="ic:outline-print"
                      />
                      Print
                    </button> */}
                  </div>
                </div>
                <table
                  className={
                    'table table-bordered text-center w-100 align-middle'
                  }
                  // style={{ marginTop: "40px" }}
                >
                  <thead style={{ backgroundColor: '#627282' }}>
                    <tr>
                      <th
                        style={{
                          color: '#fff',
                          backgroundColor: '#627282',
                          width: '200px',
                        }}
                      >
                        Sr.No
                      </th>
                      <th style={{ color: '#fff', backgroundColor: '#627282' }}>
                        Template Name
                      </th>
                      <th
                        style={{
                          textAlign: 'right',
                          paddingRight: '50px',
                          color: '#fff',
                          backgroundColor: '#627282',
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className={'w-100'}>
                    {allCategories?.map((x, index) => (
                      <tr
                        key={x.Id}
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          navigate(`/diamond_size_weight_rate_template/${x.Id}`)
                        }
                      >
                        <td>{index + 1}</td>
                        <td>
                          {x.TemplateName === '' ? 'Default' : x.TemplateName}
                        </td>
                        <td
                          style={{
                            textAlign: 'right',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '20px',
                          }}
                        >
                          {/* <div
                                // className="adminAddCategoryEditButton"
                                // onClick={(e) => handleDeleteDatalist(e, x)}
                                onClick={(e) => handleTemplateDownload(e, x)} style={{
                                cursor: "pointer",
                                display: "inline-block",
                                marginRight: "10px"
                            }}
                            >
                                <DownloadIcon/>
                            </div> */}
                          <Icon
                            onClick={(e) => handleTemplateDownload(e, x)}
                            style={{ color: '#627282', cursor: 'pointer' }}
                            icon="line-md:download"
                            width="20"
                            height="20"
                          />

                          <Icon
                            onClick={(e) => handleEditClick(e, x, index)}
                            style={{ color: '#627282', cursor: 'pointer' }}
                            icon="material-symbols-light:edit-outline"
                            width="20"
                            height="20"
                          />
                          {/* <button
                                className="adminAddCategoryEditButton"
                                onClick={(e) => handleEditClick(e, x, index)}
                            >
                                Edit
                            </button> */}
                          <Icon
                            onClick={(e) => handleDeleteDatalist(e, x)}
                            style={{ color: '#627282', cursor: 'pointer' }}
                            icon="weui:delete-filled"
                            width="20"
                            height="20"
                          />

                          {/* <button
                            className="adminAddCategoryEditButton"
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.3)",
                              marginLeft: "10px",
                              borderColor: "red",
                              color: "red",
                            }}
                            onClick={(e) => handleDeleteDatalist(e, x)}
                          >
                            Delete
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form style={{ width: '100%' }} onSubmit={handleAdd}>
                    <div
                      style={{
                        gridTemplateColumns: 'repeat(5,1fr)',
                        columnGap: '40px',
                      }}
                      className="adminCategoryAddCategoryInnerBox"
                    >
                      {/*Field sequence changed by dnyaneshwar on 28/01/2025*/}
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className={'me-2'}>Template Name</label>
                        <input
                          name="TemplateName"
                          value={newCategory.TemplateName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          className={style['addCategory-input']}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className={'me-2'}>
                          Diamond Name <sup>*</sup>
                        </label>
                        <select
                          name="DiamondShape"
                          style={{ width: '100%' }}
                          value={newCategory.DiamondShape}
                          onChange={handleNewCategoryChange}
                          required={true}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        >
                          <option value={''}>-- Select -- </option>
                          {diamondShapes.map((shape) => (
                            <option key={shape.Id} value={shape.Id}>
                              {shape.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className={'me-2'}>
                          Diamond Shape <sup>*</sup>
                        </label>
                        <select
                          name="DiamondShape"
                          style={{ width: '100%' }}
                          value={newCategory.DiamondShape}
                          onChange={handleNewCategoryChange}
                          required={true}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        >
                          <option value={''}>-- Select -- </option>
                          {diamondShapes.map((shape) => (
                            <option key={shape.Id} value={shape.Id}>
                              {shape.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className={'me-2'}>Diamond Clarity </label>

                        <select
                          name="DiamondClarity"
                          value={newCategory.DiamondClarity}
                          style={{ width: '100%' }}
                          onChange={handleNewCategoryChange}
                          ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                        >
                          <option value={''}>-- select --</option>
                          {diamondClarities.map((clarity) => (
                            <option key={clarity.Id} value={clarity.Id}>
                              {clarity.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className={'me-2'}>Diamond Color </label>
                        <select
                          name="DiamondColor"
                          value={newCategory.DiamondColor}
                          style={{ width: '100%' }}
                          onChange={handleNewCategoryChange}
                          ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        >
                          <option value={''}>-- Select --</option>
                          {diamondColors.map((colour) => (
                            <option key={colour.Id} value={colour.Id}>
                              {colour.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className={'me-2'}>Diamond Cut </label>
                        <select
                          name="DiamondCut"
                          value={newCategory.DiamondCut}
                          style={{ width: '100%' }}
                          onChange={handleNewCategoryChange}
                          ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        >
                          <option value={''}>-- Select --</option>

                          {diamondCuts.map((cut) => (
                            <option key={cut.Id} value={cut.Id}>
                              {cut.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className={'me-2'}>Diamond Setting Type</label>
                        <select
                          name="SettingType"
                          value={newCategory.SettingType}
                          style={{ width: '100%' }}
                          onChange={handleNewCategoryChange}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        >
                          <option value={''}>Select Setting Type</option>
                          {settingTypes.map((setting) => (
                            <option key={setting.Id} value={setting.Id}>
                              {setting.DiamondValue}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>
                          Diamond Size <sup>*</sup>
                        </label>
                        <input
                          name="DiamondSize"
                          value={newCategory.DiamondSize}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required={true}
                          className={style['addCategory-input']}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Sleve</label>
                        <input
                          name="Sleve"
                          value={newCategory.Sleve}
                          onChange={handleNewCategoryChange}
                          type="text"
                          className={style['addCategory-input']}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>
                          Diamond Weight <sup>*</sup>
                        </label>
                        <input
                          name="DiamondWeight"
                          value={newCategory.DiamondWeight}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required={true}
                          className={style['addCategory-input']}
                          ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Diamond Purchase Rate</label>
                        <input
                          name="DiamondPurchaseRate"
                          value={newCategory.DiamondPurchaseRate}
                          onChange={handleNewCategoryChange}
                          type="text"
                          className={style['addCategory-input']}
                          ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Diamond Margin</label>
                        <input
                          name="DiamondMargin"
                          value={newCategory.DiamondMargin}
                          onChange={handleNewCategoryChange}
                          type="text"
                          className={style['addCategory-input']}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        />
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label>Diamond Sell Rate</label>
                        <input
                          name="DiamondSellRate"
                          value={newCategory.DiamondSellRate}
                          onChange={handleNewCategoryChange}
                          type="text"
                          className={style['addCategory-input']}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        />
                      </div>
                    </div>
                    <div className={style['btn-container']}>
                      <button onClick={addNewCategory}>
                        <Icon width="24px" icon="ic:sharp-check" /> Submit
                      </button>
                      <button>
                        <Icon width="24px" icon="ic:sharp-add" /> Add
                      </button>

                      <button onClick={handleImportClick}>
                        <Icon icon="mynaui:download" width="24" height="24" />
                        Import
                      </button>
                      <button onClick={handleDownload}>
                        <Icon
                          icon="ic:baseline-download"
                          width="24"
                          height="24"
                        />
                        Download Sample
                      </button>
                      <button onClick={() => setActive('List')}>
                        {/* <Icon icon="ic:baseline-download" width="24" height="24" /> */}
                        All Diamonds
                      </button>
                    </div>
                  </form>

                  <table
                    className={
                      'table table-bordered text-center w-100 align-middle'
                    }
                    style={{ marginTop: '40px' }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: '#627282' }}>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Sr.No
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Template Name
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Shape
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Clarity
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Color
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Size
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Sieve
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Weight
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia. Purchase Rate
                        </th>
                        <th
                          style={{ color: '#fff', backgroundColor: '#627282' }}
                        >
                          Dia.z Sell Rate
                        </th>
                        <th
                          style={{
                            fontSize: '12px',
                            position: 'sticky',
                            right: 0,
                            background: '#627282',
                            zIndex: 1,
                            color: '#fff',
                          }}
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className={'w-100'}>
                      {allTableData?.map((item, index) => (
                        <tr
                          key={item}
                          //  style={{ cursor: "pointer" }}
                          //   onClick={() =>
                          //     navigate(`/diamond_size_weight_rate_template/${x.Id}`)
                          //   }
                        >
                          <td>{index + 1}</td>
                          <td>
                            {item.TemplateName == ''
                              ? 'Default'
                              : item.TemplateName}
                          </td>
                          <td>{item.DiamondShape}</td>
                          <td>{item.DiamondClarity}</td>
                          <td>{item.DiamondColor}</td>
                          <td>{item.DiamondSize}</td>
                          <td>{item.Sleve}</td>
                          <td>{item.DiamondWeight}</td>
                          <td>{item.DiamondPurchaseRate}</td>
                          {/*<td>{item.DiamondMargin}</td>*/}
                          <td>{item.DiamondSellRate}</td>
                          <td
                            style={{
                              fontSize: '12px',
                              position: 'sticky',
                              right: -9,
                              zIndex: 1,
                            }}
                          >
                            {/* <Icon
                              onClick={() => handleEditData(item, index)}
                              style={{ color: "#627282", cursor: "pointer" }}
                              icon="material-symbols-light:edit-outline"
                              width="20"
                              height="20"
                            />
                            <Icon
                              onClick={() => handleDeleteData(index)}
                              style={{ color: "#627282", cursor: "pointer" }}
                              icon="weui:delete-filled"
                              width="20"
                              height="20"
                            /> */}

                            <div className={style['action-container']}>
                              <Icon
                                onClick={() => handleEditData(item, index)}
                                style={{ color: '#627282', cursor: 'pointer' }}
                                icon="material-symbols-light:edit-outline"
                                width="20"
                                height="20"
                              />
                              <Icon
                                style={{ color: '#627282', cursor: 'pointer' }}
                                onClick={() => handleDeleteData(index)}
                                icon="weui:delete-filled"
                                width="20"
                                height="20"
                              />
                              <Icon
                                style={{ color: '#627282', cursor: 'pointer' }}
                                icon="ic:outline-print"
                                width="20"
                                height="20"
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
